import { render } from "./Sorting.vue?vue&type=template&id=2ad3c5ca&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"

import "./Sorting.vue?vue&type=style&index=0&id=2ad3c5ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad3c5ca"]])

export default __exports__